(() => {
  const syncInvoiceFields = (clearWhenOff = false) => {
    const toggle = document.getElementById('KirovaInvoiceToggle');
    const invoiceValue = document.getElementById('KirovaInvoiceValue');
    const fields = document.getElementById('KirovaInvoiceFields');
    if (!toggle || !invoiceValue || !fields) return;

    const enabled = toggle.checked;
    invoiceValue.value = enabled ? 'Да' : 'Не';
    fields.hidden = !enabled;
    toggle.setAttribute('aria-expanded', enabled ? 'true' : 'false');

    fields.querySelectorAll('[data-invoice-required]').forEach((field) => {
      field.required = enabled;
    });

    if (!enabled && clearWhenOff) {
      fields.querySelectorAll('input, textarea, select').forEach((field) => {
        if (field.type === 'checkbox' || field.type === 'radio') {
          field.checked = false;
        } else {
          field.value = '';
        }
      });
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target && event.target.id === 'KirovaInvoiceToggle') {
      syncInvoiceFields(true);
    }
  });

  const init = () => syncInvoiceFields(false);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
